import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { AppRegisterComponent } from './app-register/app-register.component';

@Component({
  selector: 'app-apps-list',
  templateUrl: './apps-list.component.html',
  styleUrls: ['./apps-list.component.css']
})
export class AppsListComponent implements OnInit {
  accountId: any;
  appData: any = [];
  constructor(private route: ActivatedRoute,
    private dialog: MatDialog, private router: Router, private activatedRoute: ActivatedRoute, private accountService: AccountService) { }

  ngOnInit(): void {
    this.route.parent.params.subscribe(params => {
      this.accountId = params['id'];
      this.getData()
    });
  }
  getData() {
    this.accountService.getData(this.accountId)
      .subscribe(res => {
        this.appData = res;
      });
  }
  registerApp(temp) {
    const dialogRef = this.dialog.open(AppRegisterComponent, {
      width: '600px',
      data: { 'accountId': this.accountId}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getData()
    });
  }
}
